export enum EmbedErrorCode {
  InvalidURI = 'invalid_uri',
}

export type EmbedError = {
  code: EmbedErrorCode;
  message: string;
  recoverable: boolean;
};

export enum IframeAPIEvent {
  READY = 'ready',
  PLAYBACK_UPDATE = 'playback_update',
  ERROR = 'error',
}

export enum IframeCommands {
  PLAY_FROM_START = 'play_from_start',
  PLAY = 'play',
  PAUSE = 'pause',
  RESUME = 'resume',
  TOGGLE_PLAY = 'toggle',
  SEEK = 'seek',
  LOAD_COMPLETE_ACK = 'load_complete_ack',
}

export type EmbedEventHandler = (eventObject: {
  data: Record<string, string | number | boolean | null>;
}) => void;

type EmbedTheme = 'colorExtraction' | 'dark';

export type EmbedIframeOptions = {
  width?: string;
  height?: string;
  uri?: string;
  startAt?: string;
  preferVideo?: boolean;
  theme?: EmbedTheme;
};

export type IframeCommandMessage = {
  command: IframeCommands;
  [key: string]: string | number;
};

export type PlaybackState = {
  isPaused: boolean;
  isBuffering: boolean;
  duration: number | null;
  positionAsOfTimestamp: number | null;
};
